import React, { useEffect, useState } from 'react';
import { ChargebacksService } from '../../../services/ChargebacksService';
import { dateToLocal, formatMoney, handleErrorToast } from '../../shared/Functions';
import '../../../scss/UVP.scss';
import { CircularProgress, Grid, Link } from '@material-ui/core';
import { getChargebacksBatch } from '../../shared/ExportFunctions';
import { CustomTable } from '../../shared/CustomTable';

export const UVPReturnsResults = ({errorToast, successToast, selectedBatch}) => {
    const [transactions, setTransactions] = useState<any>();
    const [batch, setBatch] = useState<any[]>([]);
    const [downloading, setDownloading] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<boolean>(true);
    const columns = [
        { title: 'District', field: '', render: (rowData) => rowData?.districtName },
        { title: 'Account', field: '', render: (rowData) => rowData?.billingAccount?.accountNumber },
        { title: 'Name', field: '', render: (rowData) => rowData?.billingAccount?.customer?.fullName },
        { title: 'Amount', field: '', render: (rowData) => formatMoney(rowData?.amount) },
        { title: transactions?.batchType === "Chargeback" ? 'Dispute Case Date' : 'Return Date', field: '', render: (rowData) => dateToLocal(rowData.returnDate).toLocaleDateString() },
        { title: transactions?.batchType === "Chargeback" ? 'Dispute Reason' : 'ACH Return Reason', field: '', render: (rowData) => rowData?.returnReason },
        { title: 'Payment Status', field: '', render: (rowData) => rowData?.canceled ? "Canceled" : transactions?.batchType === "Chargeback" ? "Chargeback" : "ACH Return" },
        { title: 'Payment Channel', field: '', render: () => "Returned Payment" },
        { title: 'Error Reason', field: '', render: (rowData) => rowData?.errorReason }
    ];

    useEffect(() => {
        ChargebacksService.chargebacksVGetBatch(selectedBatch.id)
            .then((x: any) => {
                setBatch(x)
                setTransactions(x)
            }).catch(x => {
                errorToast(handleErrorToast(x))
            })
    }, [selectedBatch])// eslint-disable-line react-hooks/exhaustive-deps

    const download = () => {
        setDownloading(true)
        getChargebacksBatch(selectedBatch.id, (new Date()).toLocaleString())
            .then(x => {setDownloading(false)})
            .catch(err => {
                errorToast(handleErrorToast(err))
                setDownloading(false)
            })
    }

    if(!transactions || !batch) return null;
    return (
        <React.Fragment>
            <Grid style={{backgroundColor: "white", padding: "20px 0px 0px 0px"}}>
                <Grid container style={{margin: "0px 0px 0px 0px", padding: "0px", fontSize: "14px"}}>
                    <Grid item xs={1}>
                        <b>Batch ID: </b>{transactions?.batchId}
                    </Grid>
                    <Grid item xs={2}>
                        <b>Run Date: </b>{!transactions?.runDate ? "N/A" : dateToLocal(transactions.runDate).toLocaleString()}
                    </Grid>
                    <Grid item xs={2}>
                        <b>Total Value: </b>{formatMoney(transactions?.totalAmount ?? 0)}
                    </Grid>
                    <Grid item xs={2}>
                        <b>Total Count: </b>{transactions?.count}
                    </Grid>
                    <Grid item xs={2}>
                        {downloading && <CircularProgress size={'1em'} style={{ marginRight: "5px" }} />}
                        <b>Download: </b><Link onClick={download} className="clickable">csv</Link>
                    </Grid>
                </Grid>
                <CustomTable
                    columns={columns}
                    actions={[]}
                    pageSize={15}
                    enablePaging={false}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    dataEndpoint={(query) => {
                        return new Promise((resolve, reject) => {
                            ChargebacksService.chargebacksVGetBatch(transactions.id, query.pageNumber-1)
                            .then((x:any) => {
                                setBatch(x.chargebacks)
                                setTransactions(x)
                                resolve({
                                    items: x.chargebacks,
                                    numberOfItems: x.totalCount
                                })
                            })
                            .catch(x => reject(x))
                        })
                    }}
                    dataSet={null}
                    title={""}
                    districtId={null}
                    addedQuery={null}
                    hiddenColumns={[]}
                    setHiddenColumns={null}
                    hiddenColumnsDisabled={true}
                    tableHeight={"451px"}
                    enableSearch={false}
                    searchPlaceholder={null} />
            </Grid>
        </React.Fragment>
    );
}
